'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CarouselSection2 = require('./../carousel/CarouselSection');

var _ShopifySection = require('./../ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = '[data-testimonials]';
var CAROUSEL_SELECTOR = '[data-testimonials-carousel]';

var TestimonialCarousel = function (_CarouselSection) {
  (0, _inherits3.default)(TestimonialCarousel, _CarouselSection);

  function TestimonialCarousel(container) {
    (0, _classCallCheck3.default)(this, TestimonialCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TestimonialCarousel.__proto__ || Object.getPrototypeOf(TestimonialCarousel)).call(this, container));

    _this.carouselSelector = container.find(CAROUSEL_SELECTOR);

    _this.slick = _this.initCarousel(_this.carouselSelector);
    return _this;
  }

  (0, _createClass3.default)(TestimonialCarousel, [{
    key: 'optionOverrides',
    value: function optionOverrides() {
      return {
        arrows: false,
        dots: true,
        responsive: [{
          breakpoint: ResponsiveSizes.medium - 1,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 4,
            slidesToScroll: 1
          }
        }]
      };
    }
  }]);
  return TestimonialCarousel;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, TestimonialCarousel);